import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import {
    selectUpdateNotification,
    setUpdateNotification,
} from '../../../features/notifications/notificationsSlice'
import { useLazyGetAllUsersQuery } from '../../../services/tenant/users'
import type { ITeamMember } from '../../../types/tenant/team.types'
import Input, { InputStyles } from '../../common/Input'
import SelectBoxAsynk from '../../common/SelectBoxAsynk'
import { useAppSelector } from '@/hooks/redux'
import { UserRoleEnum } from '@/types'

export const NotificationTab: React.FC = () => {
    const dispatch = useDispatch()
    const formState = useSelector(selectUpdateNotification)
    const user = useAppSelector(state => state.auth.user)
    const isAdminUser =
        user?.role &&
        [UserRoleEnum.TENANT_ADMIN, UserRoleEnum.SUPER_ADMIN].includes(
            user.role,
        )
    const [getUsers] = useLazyGetAllUsersQuery()
    const [selectedUser, setSelectedUser] =
        useState<Partial<ITeamMember> | null>(null)

    const handleInputChange = (key: string, value: string) => {
        dispatch(setUpdateNotification({ [key]: value }))
    }

    const loadOptionsUser = async (
        search: string,
        loadedOptions: any,
        { page }: { page: number },
    ) => {
        const res = await getUsers(`page=${page}&search=${search}`).unwrap()

        return {
            options:
                res?.data.map(user => ({
                    value: user.id,
                    label: user.fullName,
                })) || [],
            hasMore: +page < (res?.pagination?.maxPages || 0),
            additional: {
                page: page + 1,
            },
        }
    }

    const handleTeamChange = (
        option: { value: number; label: string } | null,
    ) => {
        if (option) {
            const user = { id: option.value, fullName: option.label }
            setSelectedUser(user)
            dispatch(setUpdateNotification({ from: user.fullName }))
        } else {
            setSelectedUser(null)
            dispatch(setUpdateNotification({ from: null }))
        }
    }

    useEffect(() => {
        if (!isAdminUser) {
            dispatch(setUpdateNotification({ from: user?.fullName || '' }))
        }
    }, [dispatch, isAdminUser, user])

    return (
        <form
            className="custom-form"
            method="POST"
        >
            <div className="custom-form-body">
                <div className="row gutters-16">
                    {isAdminUser && (
                        <div className="col-12">
                            <SelectBoxAsynk
                                wrapperClassName="input--lg select-secondary select-left-spase-0"
                                label="From (Name)"
                                fetchFunk={loadOptionsUser}
                                placeholder="Select user..."
                                onChange={handleTeamChange}
                                isMultiple={false}
                                defaultValue={formState.from}
                                value={{
                                    value: selectedUser?.id || 0,
                                    label:
                                        selectedUser?.fullName ||
                                        formState?.from,
                                }}
                            />
                        </div>
                    )}
                    <div className="col-12">
                        <Input
                            inputStyle={InputStyles.outline}
                            label="Subject"
                            placeholder="Enter subject..."
                            value={formState.title || ''}
                            onChange={e =>
                                handleInputChange('title', e.target.value)
                            }
                        />
                    </div>
                    <div className="col-12">
                        <Input
                            inputStyle={InputStyles.outline}
                            label="Description"
                            placeholder="Enter description..."
                            value={formState.description || ''}
                            onChange={e =>
                                handleInputChange('description', e.target.value)
                            }
                        />
                    </div>
                </div>
            </div>
        </form>
    )
}
